<template lang="pug">
  .lesson-list
    portal(
      v-if="course && unit"
      to="course-title"
    )
      v-btn.ml-n2.px-2.mb-4(
        color="primary"
        text exact
        :to=`{
          name: 'EducationCourseUnitList',
          params: {
            courseId: course.id,
          }
        }`
      )
        v-icon(left) mdi-arrow-left
        span Назад
      h3.text-h6.mb-1 {{ unit.title }}
      v-expansion-panels(outlined flat focusable).mb-4.mx-n2
        v-expansion-panel
          v-expansion-panel-header.primary--text.d-inline.px-2
            span.pl-2
              span.text-body-2.mb-2: strong Описание темы
            template(v-slot:actions)
              .pt-1
                v-icon.ml-2(color="primary" size="18")  $expand

          v-expansion-panel-content.text-body-1.pl-2
            .pre-wrap {{ unit.description }}

      v-tooltip(top color="error" left)
        template(#activator="{ on }")
          div(v-on="on")
            v-list-item.mb-6.mx-n2.px-2(
              v-if="unit.tasks.length"
              :disabled="!(unit.isAllLessonsComplete && !unit.user_passed)"
              @click="unit.openChatAsStudent()"
            )
              v-list-item-icon.mr-4: v-badge(
                :value="unit.hasConsultationMessages"
                color="error"
                size="10"
                overlap
                dot
                bordered
              ): v-icon(
                  :color="!(unit.isAllLessonsComplete && !unit.user_passed) ? '' : 'primary'"
                ) mdi-forum
              v-list-item-content.text-body-2: strong Консультация по теме
        span {{ consultText }}
    lesson-list(
      v-if="course && unit"
      :course="course"
      :unit="unit"
      @fetch-unit="fetchUnit"
    )
    v-skeleton-loader.fill-width(
      v-else
      type=`card-heading,
        list-item-two-line@10
      `
    )
</template>

<script>
import LessonList from '../../../components/Lessons/LessonList.vue';

export default {
  components: {
    LessonList,
  },
  props: {
    course: { type: Object, required: true },
  },
  data() {
    return {
      unit: null,
    };
  },
  computed: {
    consultText() {
      if (this.unit.user_passed) return 'Тема завершена';
      return 'Консультация по теме станет доступна после завершения всех уроков';
    },
  },
  created() {
    this.fetchUnit();
  },
  methods: {
    async fetchUnit() {
      const { item: unit } = await this.$api.courses.courseUnitShow(
        this.course.id,
        this.$route.params.unitId,
        { expand: 'lessons,tasks,user_passed' },
      );
      this.unit = unit;
    },
  },
};
</script>
